import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "../layout";
import Home from "../mycomponent/pages";
import {
  about,
  admin,
  adminblog,
  blogdetails,
  adminclinical,
  admingallery,
  adminmedical,
  adminvideo,
  blog,
  clinical,
  contact,
  dashboard,
  gallery,
  chestPainCirculatory, //1
  irregularHeartbeatsPalpitations, //2
  highBloodPressureCholesterol, //3
  heartFailureDisorders, //4
  preventiveGeneticRiskAssessment, //5
  clinicalConsultations,    //1
  interventionalCardiology,   //2
  medicalAcademicConsultation,  //3
  advancedCardiacCare,          //4
  expertDiagnosticsSpecialist,    //5
  medicalTourism,               //6
  home,
  product,
  research,
  services,
  videos,
  adminreasearchform,
  //   HealthCare,
  healthcare,
  researchcard,
  clinicaldetails,
  healthcaredetails,
  otherdetails,
  researchdetails,
  adminblognew,
  contactreport,
  metaAnalysis,
  medicalDeviceConsultation,
  medicalLanguageTranslation,
  consultation
} from "./constant";
import About from "../mycomponent/pages/about";
import Gallery from "../mycomponent/pages/gallery";
import Contact from "../mycomponent/pages/contact";
import Blog from "../mycomponent/pages/blog";
import Video from "../mycomponent/pages/video";
import Services from "../mycomponent/pages/services";
import Research from "../mycomponent/pages/research";
import BlogDetails from "../mycomponent/pages/blogdetails";
import Clinicalknowledge from "../mycomponent/pages/clinical_knowledge";
import { useEffect } from "react";
import Medicalproduct from "../mycomponent/pages/medical_product";
import Adminlayout from "../admin/admin_layout";
import { Dashboard } from "../admin/pages";
import AdminBlog from "../admin/pages/blog";
import AdminGallery from "../admin/pages/gallery";
import AdminMedicalProduct from "../admin/pages/medical_prod";
import AdminVideo from "../admin/pages/video";
import SignIn from "../admin/components/loginpage";
// import AdminClinicalLearning from "../admin/pages/clinicalLearning";
import ResearchFaq from "../admin/pages/ResearchPublication";
// import PublicationForm from "../admin/pages/PublicationForm";
import Healthcare from "../mycomponent/pages/HealthCare";
import ResearchCard from "../mycomponent/pages/ResearchCard";
import OtherDetails from "../mycomponent/pages/otherdetails";
import ClinicalDetails from "../mycomponent/pages/Clinicaldetails";
import HealthDetails from "../mycomponent/pages/HealthDetails";
import ResearchDetails from "../mycomponent/pages/ResearchDetails";
import BlogNew from "../admin/pages/blognew";
import AdminClinicalLearningZone from "../admin/pages/LearningZone";
import ContactReport from "../admin/pages/ContactReport";
import ChestPainCirculatoryIssues from "../mycomponent/pages/ChestPainCirculatoryIssues"; //1
import IrregularHeartbeatsPalpitations from "../mycomponent/pages/IrregularHeartbeatsPalpitations"; //2
import HighBloodPressureCholesterol from "../mycomponent/pages/HighBloodPressureCholesterol"; //3
import HeartFailureValveDisorders from "../mycomponent/pages/HeartFailureValveDisorders"; //4
import PreventiveGeneticRiskAssessment from "../mycomponent/pages/PreventiveGeneticRiskAssessment"; //5
import MedicalServices from "../mycomponent/pages/MedicalServices";
import ClinicalConsultations from "../mycomponent/pages/ClinicalConsultations";
import InterventionalCardiology from "../mycomponent/pages/InterventionalCardiology";
import MedicalAcademicConsultation from "../mycomponent/pages/MedicalAcademicConsultation";
import AdvancedCardiacCare from "../mycomponent/pages/AdvancedCardiacCare";
import ExpertDiagnosticsSpecialist from "../mycomponent/pages/ExpertDiagnosticsSpecialist";
import MetaAnalysis from "../mycomponent/pages/MetaAnalysis";
import MedicalTourism from "../mycomponent/pages/MedicalTourism";
import MedicalDeviceConsultation from "../mycomponent/pages/MedicalDeviceConsultation";
import MedicalLanguageTranslation from "../mycomponent/pages/MedicalLanguageTranslation";
import ConsultationForm from "../components/services/ConsultationForm";



const RouterConfrigration = () => {
  return (
    <>
      <ScrollToTop /> {/* Scroll to top on every route change */}
      <Routes>
        {/* <Route path={nopage} element={<NoPage />} />
            <Route path={login} element={<Login />} />
            <Route path={pllogin} element={<PlLogin />} /> */}

        {/* register by mail url path */}
        {/* <Route path={register_InvitePath} element={<Register />} />
            <Route path={register} element={<Register />} /> */}

        {/* forgot by mail url path */}
        {/* <Route path={forgotPath} element={<Forgot />} />
            <Route path={forgot} element={<Forgot />} /> */}

        <Route path={home} element={<Layout />}>
          <Route index path={home} element={<Home />} />
          <Route path={about} element={<About />} />
          <Route path={blog} element={<Blog />} />
          <Route path={gallery} element={<Gallery />} />
          
          <Route
            path={chestPainCirculatory}
            element={<ChestPainCirculatoryIssues />} //1
          />
          <Route
            path={irregularHeartbeatsPalpitations}
            element={<IrregularHeartbeatsPalpitations />} //2
          />
          <Route
            path={highBloodPressureCholesterol}
            element={<HighBloodPressureCholesterol />} //3
          />
          <Route
            path={heartFailureDisorders}
            element={<HeartFailureValveDisorders />} //4
          />
          <Route
            path={preventiveGeneticRiskAssessment}
            element={<PreventiveGeneticRiskAssessment />} //5
          />
          
                    <Route
            path={clinicalConsultations}
            element={<ClinicalConsultations />} //1
          />
                    <Route
            path={interventionalCardiology}
            element={<InterventionalCardiology />} //2
          />
                    <Route
            path={medicalAcademicConsultation}
            element={<MedicalAcademicConsultation />} //3
          />
                    <Route
            path={advancedCardiacCare}
            element={<AdvancedCardiacCare />} //4
          />
                    <Route
            path={expertDiagnosticsSpecialist}
            element={<ExpertDiagnosticsSpecialist />} //5
          />
                    <Route
            path={medicalTourism}
            element={<MedicalTourism />} //6
          />
          <Route path={metaAnalysis} element={<MetaAnalysis />} />
          <Route path={medicalDeviceConsultation} element={<MedicalDeviceConsultation />} />
          <Route path={medicalLanguageTranslation} element={<MedicalLanguageTranslation />} />
          <Route path={contact} element={<Contact />} />
          <Route path={videos} element={<Video />} />
          <Route path={services} element={<Services />} />
          <Route path={research} element={<Research />} />
          <Route path={clinical} element={<Clinicalknowledge />} />
          <Route path={product} element={<Medicalproduct />} />
          <Route path={healthcare} element={<Healthcare />} />
          <Route path={researchcard} element={<ResearchCard />} />
          <Route path={consultation} element={<ConsultationForm />} />
          {/* <Route path={blogdetails} element={<BlogDetails />} /> */}
          <Route path={`${blogdetails}/:id`} element={<BlogDetails />} />
          <Route
            path={`${researchdetails}/:id`}
            element={<ResearchDetails />}
          />
          <Route
            path={`${clinicaldetails}/:id`}
            element={<ClinicalDetails />}
          />
          <Route
            path={`${healthcaredetails}/:id`}
            element={<HealthDetails />}
          />
          <Route path={`${otherdetails}/:id`} element={<OtherDetails />} />
        </Route>

        <Route path={admin} element={<SignIn />} />
        

        <Route path={admin} element={<Adminlayout />}>
          <Route path={dashboard} element={<Dashboard />} />
          <Route path={adminblog} element={<AdminBlog />} />
          <Route path={adminblognew} element={<BlogNew />} />
          <Route path={admingallery} element={<AdminGallery />} />
          <Route path={adminmedical} element={<AdminMedicalProduct />} />
          <Route path={adminvideo} element={<AdminVideo />} />
          <Route path={adminreasearchform} element={<ResearchFaq />} />
          <Route path={adminclinical} element={<AdminClinicalLearningZone />} />
          <Route path={contactreport} element={<ContactReport />} />
        </Route>
      </Routes>
    </>
  );
};

export default RouterConfrigration;

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // The component doesn't render anything
};
